import { dataHooks } from '@wix/data-hooks'

export const footerControlsDataHooks = dataHooks<{
  backButton: {}
  skipButton: {}
}>('footer-controls')
